import { render, staticRenderFns } from "./CompaniesDetails.vue?vue&type=template&id=77a60405"
import script from "./CompaniesDetails.vue?vue&type=script&lang=js"
export * from "./CompaniesDetails.vue?vue&type=script&lang=js"
import style0 from "./CompaniesDetails.vue?vue&type=style&index=0&id=77a60405&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports